// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__Ylgit","addWidgetButton":"Header_addWidgetButton__24zIX","dashboardTabs":"Header_dashboardTabs__27ly5","active":"Header_active__3vM80"};